<nav class="sidebar" aria-label="Main navigation">
  <!-- Logo block -->
  <div class="sidebar__header">
    <div class="sidebar__logo-mark">D</div>
    <div class="sidebar__logo-text">
      <div class="sidebar__logo-name">Davaco</div>
      <div class="sidebar__logo-subtitle">Operations · PROD</div>
    </div>
    <app-icon name="chevron-down" [size]="14" class="sidebar__logo-chevron" />
  </div>

  <!-- Quick search -->
  <div class="sidebar__search">
    <app-icon name="search" [size]="14" />
    <span class="sidebar__search-text">Search...</span>
    <span class="sidebar__search-kbd">
      <span class="kbd">⌘</span>
      <span class="kbd">K</span>
    </span>
  </div>

  <!-- Navigation groups -->
  <div class="sidebar__nav-container">
    @for (group of visibleGroups(); track group.label) {
      <div class="sidebar__nav-group">
        <div class="sidebar__nav-group-label">{{ group.label }}</div>
        <ul class="sidebar__nav-list" role="list">
          @for (item of group.items; track item.route) {
            <li class="sidebar__nav-item">
              <a
                [routerLink]="item.route"
                [class.sidebar__nav-link--active]="isActive(item.route)"
                class="sidebar__nav-link"
              >
                <app-icon [name]="item.icon" [size]="15" />
                <span class="sidebar__nav-label">{{ item.label }}</span>
                @if (item.badge) {
                  <span class="sidebar__nav-badge">{{ item.badge }}</span>
                }
              </a>
            </li>
          }
        </ul>
      </div>
    }
  </div>

  <!-- User footer -->
  <div class="sidebar__footer">
    <app-avatar [imageUrl]="avatarUrl()" [initials]="profile().initials" [size]="36" />
    <div class="sidebar__user-info">
      <div class="sidebar__user-name">{{ profile().displayName }}</div>
      <div class="sidebar__user-role">{{ profile().primaryRoleLabel }}</div>
    </div>
    <button class="sidebar__logout" type="button" (click)="onLogout()" aria-label="Logout">
      <app-icon name="logout" [size]="14" />
    </button>
  </div>
</nav>
